import { batch } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import {
  positionsRegistry,
  togglePositionVisibilityRequestAction,
} from '@root/entities/position'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui'

import type { Network } from '@root/entities/network'
import type { PairAddress } from '@root/entities/pair'

export const reatomPositionVisibilityToggle = ({
  pairAddress,
  network,
}: {
  pairAddress: PairAddress
  network: Network.Network
}) => {
  const requestState = reatomRequest({
    execAction: togglePositionVisibilityRequestAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: `reatomPositionVisibilityToggle_${pairAddress}`,
    prepare: (_) => ({ pairAddress, network }),
    onResult: (ctx, result) => {
      if (Result.isSuccess(result)) {
        batch(ctx, () => {
          if (Array.isArray(result.success.data)) {
            for (const it of result.success.data) {
              positionsRegistry.updateWalletPositionFromDto(ctx, it)
            }
          } else {
            positionsRegistry.updateWalletPositionFromDto(
              ctx,
              result.success.data,
            )
          }
        })

        return
      }

      showErrorSnackbarAction(ctx, result.failure)
    },
  })

  return requestState
}
